import { NavLink } from "react-router-dom";
import { services } from "../../../../globals/neuron-content";

function SectionServices1() {
  return (
    <>
      <div className="section-full p-t110 p-b80 sx-our-services-outer sx-bg-light">
        <div className="container">
          <div className="section-head center">
            <div className="sx-head-s-title">Our Services</div>
            <div className="sx-head-l-title"><h2 className="sx-title">Protective solutions tailored to operational realities</h2></div>
          </div>
          <div className="section-content">
            <div className="sx-our-services-bx">
              <div className="row">
                {services.map((service, idx) => (
                  <div key={service.title} className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                    <div className="sx-service-bx-1">
                      <div className="sx-icon-box-wraper">
                        <div className="sx-service-bx-icon scale-in-center"><span className="sx-text-primary"><i className={service.icon} /></span></div>
                        <div className="icon-content">
                          <h4 className="sx-tilte">{service.title}</h4>
                          <p>{service.detail}</p>
                          <div className="sx-center-btn">
                            <NavLink to={`/services/${service.slug}`} className={`site-button-circle ${idx === 1 ? "active" : ""}`}><i className="fa fa-long-arrow-right" /></NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionServices1;
